import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { CONSENT_STORAGE_KEY, updateAnalyticsConsent } from "@/lib/analytics";

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const storedConsent = window.localStorage.getItem(CONSENT_STORAGE_KEY);
    if (!storedConsent) {
      setIsVisible(true);
    }
  }, []);

  const handleChoice = (choice: "accepted" | "declined") => {
    window.localStorage.setItem(CONSENT_STORAGE_KEY, choice);
    updateAnalyticsConsent(choice);
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div
      role="region"
      aria-label="Cookie consent"
      className="fixed inset-x-0 bottom-0 z-50 border-t border-border bg-card shadow-[0_-8px_30px_rgba(0,0,0,0.3)]"
    >
      <div className="container mx-auto px-4 md:px-6 py-4 sm:py-5">
        <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center gap-4 sm:gap-6">
          <p className="text-sm text-muted-foreground text-center sm:text-left flex-1">
            We use cookies to run this site and understand how it's used. You can accept or decline non-essential cookies at any time. See our{" "}
            {/* text-primary fails WCAG AA contrast (~2.85:1) against this card
                background — lightened to clear 4.5:1. */}
            <Link
              to="/privacy-policy"
              className="text-[hsl(245,75%,72%)] hover:underline underline-offset-4"
            >
              Privacy Policy
            </Link>{" "}
            for details.
          </p>
          <div className="flex items-center gap-3 flex-shrink-0">
            <Button
              variant="outline"
              size="sm"
              onClick={() => handleChoice("declined")}
            >
              Decline
            </Button>
            <Button
              size="sm"
              className="bg-primary text-primary-foreground hover:bg-primary/90"
              onClick={() => handleChoice("accepted")}
            >
              Accept
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
